import { EllipsisVertical } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const OptionsIcon = DeckardIconWrapper({ Icon: EllipsisVertical });
